<div class="border rounded text-center p-2 bg-{{ type }}-light border-color-{{ type }}-dark">
  {{ text | translate }}
</div>
